import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mb-20" }
const _hoisted_2 = { class: "col-12 p-0 p-0 px-sm-15" }
const _hoisted_3 = { class: "col-12 p-0 p-0 px-sm-15 mt-20" }
const _hoisted_4 = {
  id: "confermaFilter",
  ref: "confermaFilter",
  class: "container p-0 m-0 d-flex justify-content-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_select = _resolveComponent("base-select")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_bt_modal = _resolveComponent("base-bt-modal")!

  return (_openBlock(), _createBlock(_component_base_bt_modal, {
    id: "filter-agency-modal",
    "data-cy": "filter-agency-modal",
    "show-modal": _ctx.show,
    "custom-modal-dialog-classes": "modal-lg",
    "custom-modal-footer-classes": "p-0 m-0 border-0 pb-50 pb-sm-20",
    "custom-modal-content-classes": "overflow-visible",
    "with-custom-header": false,
    "with-custom-footer": true,
    "header-title": _ctx.labels.filtersSearch,
    onClosed: _ctx.hideAgencyFiltersModal
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_base_input, {
            modelValue: _ctx.agencyFilter.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.agencyFilter.name) = $event)),
            "label-text": _ctx.labels.generic_name
          }, null, 8 /* PROPS */, ["modelValue", "label-text"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_base_select, {
            id: "agency-group-select",
            "data-cy": "agency-group-select",
            "label-text": _ctx.labels.generic_group,
            "model-value": _ctx.currentSearchFranchiseOptions ?? undefined,
            options: _ctx.franchiseList,
            "dropdown-position": _ctx.isDesktopMode?'down':'up',
            "onUpdate:modelValue": _cache[1] || (_cache[1] = opt => { _ctx.agencyFilter.franchiseId = opt.id; _ctx.agencyFilter.uri = opt.uri; _ctx.currentSearchFranchiseIdName = opt.label})
          }, null, 8 /* PROPS */, ["label-text", "model-value", "options", "dropdown-position"])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_base_button, {
          class: _normalizeClass(["btn-w-primary btn-md", {'btn-block' :!_ctx.isDesktopMode}]),
          onClick: _withModifiers(_ctx.confirmFilter, ["stop"])
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.labels.confirm), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["class", "onClick"])
      ], 512 /* NEED_PATCH */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show-modal", "header-title", "onClosed"]))
}